import { connect, MapStateToProps, MapDispatchToProps } from 'react-redux';
import { Props } from './ExpandButton';
import { requestToggleFullscreenView } from '../../../DeviationPage/redux/actions';
import { getIsFullscreenAllowed } from '../../../DeviationPage/redux/selectors';

type StateProps = Pick<Props, 'canFullscreen'>;

type DispatchProps = Pick<Props, 'onClick'>;
type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, {}> = (
  state,
  { deviation }
) => ({
  canFullscreen: getIsFullscreenAllowed(state),
});

const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = {
  onClick: requestToggleFullscreenView,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
);
